<main class="account-page">
  <section class="account-card">
    <p class="eyebrow">Self-Service Setup</p>
    <h1>Create your account</h1>
    <p class="lede">
      Use the email that was approved for Hebern access. We will send a passcode
      to verify it.
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()" class="account-form">
      <label>
        <span>Name</span>
        <input
          type="text"
          formControlName="name"
          autocomplete="name"
          placeholder="Your name"
        />
        @if (form.controls.name.invalid && form.controls.name.touched) {
        <small>Name is required.</small>
        }
      </label>

      <label>
        <span>Email</span>
        <input
          type="email"
          formControlName="email"
          autocomplete="email"
          placeholder="you@example.com"
          [attr.readonly]="emailLocked ? true : null"
        />
        @if (form.controls.email.invalid && form.controls.email.touched) {
        <small>Please enter a valid email.</small>
        }
      </label>

      <label>
        <span>Password</span>
        <input
          type="password"
          formControlName="password"
          autocomplete="new-password"
          placeholder="At least 8 characters"
        />
        @if (form.controls.password.invalid && form.controls.password.touched) {
        <small>Password must be at least 8 characters.</small>
        }
      </label>

      <label>
        <span>Re-enter password</span>
        <input
          type="password"
          formControlName="confirmPassword"
          autocomplete="new-password"
          placeholder="Re-enter password"
        />
        @if (form.controls.confirmPassword.hasError('mismatch')) {
        <small>Passwords do not match.</small>
        } @else if (form.controls.confirmPassword.invalid &&
        form.controls.confirmPassword.touched) {
        <small>Please re-enter your password.</small>
        }
      </label>

      @if (errorMessage) {
      <div class="form-alert form-alert--error">{{ errorMessage }}</div>
      }

      <button type="submit" class="primary-action" [disabled]="isLoading">
        {{ isLoading ? 'Creating account...' : 'Create Account' }}
      </button>
    </form>

    <div class="account-links">
      <a routerLink="/login">Already have an account?</a>
    </div>
  </section>
</main>
